<template>
  <fn-action-box
    :clickable="false"
    :class="{
      'action-box--error': error,
      'action-box--info': info,
      'action-box--success': success,
      'action-box--plain': plain,
      'action-box--no-margin': noMargin,
    }"
    :borderless="borderless"
    :centered="centered"
    :inline-links="inlineLinks"
  >
    <template
      v-if="showIcon"
      #before
    >
      <fn-icon
        :size="iconSize"
        :icon="iconSymbol"
        :color="iconColor"
      />
    </template>
    <template #default>
      <slot />
    </template>
  </fn-action-box>
</template>

<script>
export default {
  props: {
    error: {
      type: Boolean,
    },
    inlineLinks: {
      type: Boolean,
    },
    success: {
      type: Boolean,
    },
    plain: {
      type: Boolean,
    },
    showIcon: {
      type: Boolean,
      default: true,
    },
    borderless: {
      type: Boolean,
    },
    centered: {
      type: Boolean,
    },
    info: {
      type: Boolean,
    },
    iconSize: {
      type: String,
      default: 'xs',
    },
    noMargin: {
      type: Boolean,
    },
  },
  computed: {
    iconSymbol() {
      return this.info ? 'circle-i-light' : 'alert';
    },

    iconColor() {
      if (this.error) {
        return 'red';
      }

      if (this.info) {
        return 'orientation-blue';
      }

      return 'green-dark';
    },
  },
};
</script>

<style lang="scss" scoped>
.action-box {
  background-color: palette(sand, light);
  border-color: palette(sand);
  margin-bottom: $pad;

  &:last-child {
    margin-bottom: 0;
  }

  &.action-box--error {
    border-radius: map-get($border-radiuses, xl);
    align-items: center;
    background-color: $color-general-background-status-negative-default;
    color: $color-general-text-status-negative-default;
    border: none;

    :deep(a) {
      color: $color-action-text-error-default-base;
    }

    :deep(.ab-before) {
      margin-right: 0.625 * $pad;
    }
    @include bp(m, max) {
      :deep(.ab-main, .ab-after) {
        font-size: map-get($font-sizes, m);
      }
    }
  }

  &.action-box--info {
    background-color: palette(background, blue);
    border-color: palette(orientation, blue);
    color: palette(orientation, blue);
  }

  &.action-box--success {
    background-color: $color-general-background-neutral-default;
    border-color: $color-brand-fnmz-green;
    color: $color-brand-fnmz-green;
  }

  &.action-box--plain {
    background-color: $color-general-background-neutral-default;
    border-color: palette(grey, light);
    color: palette(grey, dark);
  }

  &.action-box--no-margin {
    margin: 0;
  }

  .ab-icon {
    line-height: map-get($font-line-heights, 's');
  }
}
</style>
